import './App.less';
import {Provider as InversifyProvider, useInjection} from 'inversify-react';
import {Provider, useDispatch, useSelector} from 'react-redux'
import {store} from './redux/store';
import RoutingContainer, {RoutingPaths} from "./pages/routing/routingContainer";
import React, {useCallback, useEffect} from "react";
import ApiService from "./services/apiService";
import SiderMenu from './pages/components/siderMenu/siderMenu';
import HeaderContainer from './pages/components/header/headerContainer';
import FooterContainer from './pages/components/footer/footerContainer';
import {CrudBreadcrumb, CrudLayout} from 'digimuth-components/dist';
import {Container} from 'inversify';
import {AuthProvider, AuthProviderProps, initUserManager, useAuth, UserManager} from 'oidc-react';
import {ConfigProvider, ThemeConfig} from 'antd';
import plPL from 'antd/lib/locale/pl_PL';
import {createBrowserHistory} from "history";
import {unstable_HistoryRouter as HistoryRouter} from "react-router-dom";
import {getCurrentUser, setCurrentUser} from "./redux/applicationUserSlice";
import {ApplicationUserApi} from "./api";

const authSettings: AuthProviderProps = {
    authority: process.env.REACT_APP_URL,
    clientId: "BeeftekaBackend.Web",
    redirectUri: process.env.REACT_APP_URL,
    autoSignIn: false,
    automaticSilentRenew: true,
    scope: "openid BeeftekaBackend.WebAPI profile"
};

export const userManager: UserManager | undefined = initUserManager(authSettings);

const customTheme: ThemeConfig = {
    token: {
        colorPrimary: '#016f71',
        colorWarning: '#DE6826',
        borderRadius: 4,
        colorBgContainerDisabled: '#adcccc',
        controlHeight: 36,
    },
    components: {
        Layout: {
            headerBg: '#242424',
            triggerBg: '#353535',
            bodyBg: '#fefefe',
            siderBg: "#353535",
            controlItemBgActive: "#353535"
        },
        Menu: {
            darkItemBg: "#353535",
            itemBorderRadius: 0,
            itemMarginInline: 0
        }
    }
};

function App() {
    const history = createBrowserHistory();
    const container = new Container();
    container.bind(ApiService).toSelf();

    return (
        /*
      // @ts-ignore */
        <AuthProvider
            autoSignIn={false}
            userManager={userManager}
            onSignIn={u => {
                const userState = u?.state as any;
                const fromState = userState.targetPath;
                const targetUrl = fromState ? fromState : "/";
                history.replace(targetUrl);
            }}>
            <ConfigProvider locale={plPL}>
                <Provider store={store}>
                    <InversifyProvider container={container}>
                        {/* @ts-expect-error */}
                        <HistoryRouter history={history}>
                            <ConfigProvider theme={customTheme}>
                                <Layout/>
                            </ConfigProvider>
                        </HistoryRouter>
                    </InversifyProvider>
                </Provider>
            </ConfigProvider>
        </AuthProvider>
    )
}

function Layout() {
    const auth = useAuth();
    const apiService = useInjection(ApiService);
    const dispatch = useDispatch();
    const currentUser = useSelector(getCurrentUser);

    const updateCurrentUserInStore = useCallback(async () => {
        const response = await apiService.getApi(ApplicationUserApi)
            .apiApplicationUserIdGet(Number(auth.userData?.profile.sub));
        dispatch(setCurrentUser(response.data));
        checkLocation(response.data.roles?.length!)
    }, [auth.userData, apiService, dispatch]);

    const checkLocation = (rolesCount: number) => {
        if (rolesCount === 0) {
            window.location.href = process.env.REACT_APP_STORE_URL!;
        }
    }

    useEffect(() => {
        if (!currentUser && auth.userData) {
            updateCurrentUserInStore();
        }
    }, [updateCurrentUserInStore])

    return <CrudLayout
        breadcrumb={auth.userData ? <CrudBreadcrumb routingDefinitions={RoutingPaths}/> : <></>}
        siderMenu={<SiderMenu/>}
        header={<HeaderContainer/>}
        footerContent={<FooterContainer/>}
        showSider={!!auth.userData}
        siderFullHeight={true}
    >
        <RoutingContainer/>
    </CrudLayout>;
}

export default App;
